const shortcuts = {
    search: '/',
    gridView: '[',
    listView: ']',
};

export { shortcuts };
